import { useMemo } from 'react';
import { FinderVehicleSortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): FinderVehicleSortingField => {
    switch (field) {
        case 'module.company.displayName':
            return FinderVehicleSortingField.Company;

        case 'listing.id':
            return FinderVehicleSortingField.InventoryId;

        case 'listing.vehicle.orderTypeCode':
            return FinderVehicleSortingField.VehicleId;

        case 'name':
            return FinderVehicleSortingField.Name;

        case 'listing.vehicle.condition.value':
            return FinderVehicleSortingField.Condition;

        case 'listing.seller.name.localize':
            return FinderVehicleSortingField.DealerName;

        case 'listing.vehicle.exteriorColor.name.localize':
            return FinderVehicleSortingField.ExteriorColor;

        case 'listing.price.value':
            return FinderVehicleSortingField.Price;

        case 'setting.isInspected':
            return FinderVehicleSortingField.IsInspected;

        case 'lta':
            return FinderVehicleSortingField.HasLta;

        case 'setting.isStateHidden':
            return FinderVehicleSortingField.IsStateHidden;

        case 'setting.functionality':
            return FinderVehicleSortingField.Functionality;

        case 'status':
            return FinderVehicleSortingField.Status;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const companySort = useMemo(
        () => (sort.field === FinderVehicleSortingField.Company ? sort.orderValue : undefined),
        [sort]
    );

    const inventoryIdSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.InventoryId ? sort.orderValue : undefined),
        [sort]
    );

    const vehicleIdSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.VehicleId ? sort.orderValue : undefined),
        [sort]
    );

    const nameSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.Name ? sort.orderValue : undefined),
        [sort]
    );

    const conditionSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.Condition ? sort.orderValue : undefined),
        [sort]
    );

    const dealerNameSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.DealerName ? sort.orderValue : undefined),
        [sort]
    );

    const exteriorColorSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.ExteriorColor ? sort.orderValue : undefined),
        [sort]
    );

    const priceSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.Price ? sort.orderValue : undefined),
        [sort]
    );

    const isInspectedSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.IsInspected ? sort.orderValue : undefined),
        [sort]
    );

    const hasLtaSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.HasLta ? sort.orderValue : undefined),
        [sort]
    );

    const isStateHiddenSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.IsStateHidden ? sort.orderValue : undefined),
        [sort]
    );

    const functionalitySort = useMemo(
        () => (sort.field === FinderVehicleSortingField.Functionality ? sort.orderValue : undefined),
        [sort]
    );

    const statusSort = useMemo(
        () => (sort.field === FinderVehicleSortingField.Status ? sort.orderValue : undefined),
        [sort]
    );

    return {
        companySort,
        inventoryIdSort,
        vehicleIdSort,
        nameSort,
        conditionSort,
        dealerNameSort,
        exteriorColorSort,
        priceSort,
        isInspectedSort,
        hasLtaSort,
        isStateHiddenSort,
        functionalitySort,
        statusSort,
    };
};

export default useSortOrder;
